import { CbSpinnerModule } from '@chubb/ui-components/cb-spinner';
import { CbInputModule } from '@chubb/ui-components/cb-input';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WorkersCompJobTypeComponent } from './workers-comp-job-type.component';
import { EmpTileModule } from './emp-tile/emp-tile.module';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ProgressBarModule } from '../../../progress-bar/progress-bar.module';
import { ReactiveFormsModule, FormBuilder } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { DialogModule } from '../../../components/dialog/dialog.module';
import { AppAnalyticsModule } from '../../../directives/app-analytics.module';
@NgModule({
    declarations: [WorkersCompJobTypeComponent],
    imports: [
        CommonModule,
        CbSpinnerModule,
        ProgressSpinnerModule,
        ProgressBarModule,
        AppAnalyticsModule,
        ReactiveFormsModule,
        CbInputModule,
        MatExpansionModule,
        MatIconModule,
        MatButtonModule,
        MatCheckboxModule,
        EmpTileModule,
        DialogModule,
    ],
    exports: [WorkersCompJobTypeComponent],
})
export class WorkersCompJobTypeModule {}
